module.exports = __webpack_public_path__ + "img/structure-organization-2.564a66d4.jpg";